import { UserType } from "@inrev/common";
import { useAuthenticatedUser } from "@portal/providers/AuthenticatedUserProvider";
import { useIsMutating, useQuery } from "@tanstack/react-query";
import { ADMIN_BASE_URL, AGENT_BASE_URL } from "../../constants";
import { useRequest } from "../../utils/request";
import { BondRequestPreview } from "../bond-request/agent/types";
import { bondRequestPreviewsQueryKey } from "../bond-request/bond-request.keys";

export const useFetchBondRequestPreviews = () => {
	const { user } = useAuthenticatedUser();
	const { get } = useRequest();
	const baseUrl = user.type === UserType.admin ? ADMIN_BASE_URL : AGENT_BASE_URL;
	const isMutatingBondRequests = useIsMutating({ mutationKey: ["adminBondRequestSubmission"] });

	const { data, error, isLoading, refetch } = useQuery({
		queryKey: bondRequestPreviewsQueryKey(),
		queryFn: async () => await get<BondRequestPreview[]>(baseUrl + "/surety/quotes/previews"),
		enabled: isMutatingBondRequests === 0,
	});

	return {
		bondRequestPreviews: data,
		bondRequestPreviewsError: error,
		bondRequestPreviewsIsLoading: isLoading,
		refetchBondRequestPreviews: refetch,
	};
};
